export const SIGNUP_LOGIN_SCROLL_Y_SESSION_KEY = 'signup_login_scroll_y';

const getSessionStorage = () => window?.sessionStorage;
const getCurrentScrollY = () => window?.scrollY || window?.pageYOffset || 0;

/**
 * Save one-page-store mount state to sessionStorage.
 * Keep this API state-oriented (instead of scrollY-only) for future extensibility.
 * Currently only `initialScrollY` is persisted; calling without valid fields is a no-op by design.
 */
export const saveOnePageStoreMountState = ({ initialScrollY } = {}) => {
  try {
    const sessionStorage = getSessionStorage();

    if (!sessionStorage) return;

    if (typeof initialScrollY === 'number' && initialScrollY >= 0) {
      sessionStorage.setItem(
        SIGNUP_LOGIN_SCROLL_Y_SESSION_KEY,
        String(initialScrollY),
      );
    }
  } catch (e) {
    // Ignore storage errors (e.g. private mode or disabled storage).
    console.warn('Failed to access sessionStorage', e);
  }
};

export const saveCurrentScrollToMountState = () => {
  saveOnePageStoreMountState({
    initialScrollY: getCurrentScrollY(),
  });
};

export const consumeOnePageStoreMountState = () => {
  try {
    const sessionStorage = getSessionStorage();

    if (!sessionStorage) {
      return {
        initialScrollY: undefined,
      };
    }

    const rawInitialScrollY = sessionStorage.getItem(
      SIGNUP_LOGIN_SCROLL_Y_SESSION_KEY,
    );

    sessionStorage.removeItem(SIGNUP_LOGIN_SCROLL_Y_SESSION_KEY);

    const parsed = Number(rawInitialScrollY ?? NaN);
    const initialScrollY =
      Number.isFinite(parsed) && parsed >= 0 ? parsed : undefined;

    return {
      initialScrollY:
        Number.isFinite(initialScrollY) && initialScrollY >= 0
          ? initialScrollY
          : undefined,
    };
  } catch {
    // Fallback to an empty mount state if storage access fails.
    return {
      initialScrollY: undefined,
    };
  }
};
